import { MoreLikeThis } from './';
import { Separator, Text } from '@intigral/shared';
import { CastCrew } from '../CastCrew';
import { iTab1Props } from '../../types/iTabs';

export const Tab1: React.FC<iTab1Props> = ({ item, moreLikeThisRef }) => {
    return (
        <>
            <Separator color="dark" marginBottom={{ default: '3x' }} />
            <Text as="p" alignment="start" margin="4x" style={{ opacity: 0.9 }}>
                {item?.description}
            </Text>
            <CastCrew
                contentId={item.Id}
                meta={{ title: { ar: 'طاقم العمل', en: 'Cast & Crew' } }}
                id="movie-details_popup_castcrew"
                // style={{ position: 'relative', zIndex: '1' }}
            />
            <div ref={moreLikeThisRef} />
            <MoreLikeThis item={item} />
        </>
    );
};
